module.exports = __webpack_public_path__ + "img/icon-blank.a5301806.png";